export const communicationsDrawerId = 'aces-communications-drawer-wrapper';
